import { SxProps, Theme } from "@mui/material";

export const unselectable: SxProps<Theme> = {
  WebkitUserSelect: "none" /* Safari */,
  MozUserSelect: "none" /* Firefox */,
  msUserSelect: "none" /* IE10+/Edge */,
  userSelect: "none",
};